<div class="status-wrapper">
    <span [ngbTooltip]="tooltipTemplate" class="badge cpl-pill cpl-pill-border" [ngStyle]="{
        'border-color': pill.HexColor,
        'color': '#212529'
    }">
        <in-compliance-status-indicator *ngIf="status"
            [ngClass]="{ 'me-1': status !== InComplianceStatus.OUT_OF_COMPLIANCE }" [status]="status">
        </in-compliance-status-indicator>
        {{pill.Description}}
        <i *ngIf="isRemovable && onRemove.observed" class="fas fa-times ms-2" aria-hidden="true"
            (click)="onRemoveClicked()"></i>
    </span>
    <span *ngIf="showTitle" class="pill-title text-truncate ms-2">{{pill?.Title}}</span>
    <ng-template #tooltipTemplate>
        {{pill?.Title}}
        <div *ngIf="missingItems.length > 0" class="mt-2">
            <b>Warning:</b> The user has not been added to the following compliance items:
            <ul class="mt-1 text-start">
                <li *ngFor="let item of missingItems" class="mt-1">
                    {{item.Title}}
                </li>
            </ul>
        </div>
    </ng-template>

    <div *ngIf="showStatusStamp && status  && status == InComplianceStatus.IN_COMPLIANCE" class="status-stamp">
        <svg class="status-stamp-shape" viewBox="0 0 24 24" role="img" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
        </svg>
        <i class="stamp-icon fas fa-check"></i>
    </div>
</div>
